import React, { useCallback, useMemo, useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Controller, useFormContext } from 'react-hook-form';
import { defaultInputProps, FormProps, getRequiredValidationRule, getValidationErrorProps } from 'util/form';

interface PasswordFormItemProps extends FormProps {
  autoComplete?: 'on' | 'off';
  validate?: (value?: any) => any;
}

const PasswordFormItem: React.FunctionComponent<PasswordFormItemProps> = ({
  fieldName = 'password',
  autoComplete = 'off',
  label = 'Password',
  required = true,
  validate,
}) => {
  const [valueVisible, setValueVisible] = useState<boolean>(false);
  const { control } = useFormContext();

  const handleVisibilityClick = useCallback(() => {
    setValueVisible((prevState) => !prevState);
  }, []);

  const validationLabel = useMemo(() => label.toLocaleLowerCase(), [label]);

  return (
    <Controller
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...defaultInputProps}
          {...getValidationErrorProps(error)}
          inputRef={field.ref}
          label={label}
          type={valueVisible ? 'text' : 'password'}
          autoComplete={autoComplete}
          required={required}
          InputProps={{
            endAdornment: (
              <InputAdornment position={'end'}>
                <IconButton onClick={handleVisibilityClick}>
                  {valueVisible ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
      name={fieldName}
      control={control}
      rules={{ required: getRequiredValidationRule(validationLabel, required), validate }}
    />
  );
};

export default PasswordFormItem;
